import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { dispatch } from '../../../store/configureStore';
import { LazyWrapper } from '../lazy/lazy_wrapper';

export class TemplateSelectDialogReactToBackbone {
    el: Element;
    root: Root;
    store: Store;

    constructor (store: Store) {
        this.store = store;
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'template-select-dialog-placeholder';
        document.body.append(this.el);
        this.root = createRoot(this.el!);
        this.render();
    }

    initOpenBoardsStore() {
        return import(/* webpackChunkName: "openBoards" */ 'app/view/react_components/dialogs/openBoards/store/openBoardsReducer')
            .then((module) => {
                //@ts-ignore
                this.store.reducerManager.add('openBoardsDialog', module.openBoardsDialogReducer);
                dispatch({type: 'async-init'}); // fake action to init new reducers
            })
            .catch(e => console.error(e))
    }

    render (callback: () => void = null) {
        const ImportElement = React.lazy(() =>
            //@ts-ignore
            this.initOpenBoardsStore()
                .then(() => import(/* webpackChunkName: "openBoards" */ 'app/view/react_components/dialogs/templateSelect/hocs/TemplateSelectDialogHOC/TemplateSelectDialogHOC'))
                .then(module => {
                    if (callback) callback();
                    return { default: module.TemplateSelectDialogHOC }
                })
                .catch(e => console.error(e))
        );

        this.root.render(
            <LazyWrapper>
                <Provider store={this.store}>
                    <ImportElement />
                </Provider>
            </LazyWrapper>
        );
        return this;
    }

    remove () {
        if (!this.el) return;

        this.root.unmount();
        this.el.remove();
        this.el = null;
    }
}
